import clsx from 'clsx'
import { useState } from 'react';
import FormDrawer from "components/__new/common/form-drawer";
import SearchBox from 'components/__new/common/SearchBox';
import SlideToggle from 'components/__new/common/form/SlideToggle';



const DropDownSearch = (props) => {
    const {listClass, isOpen, setIsOpen, checkedItems, setCheckedItems} = props
    const [showAllEmployees, setShowAllEmployees] = useState(false)
    
    
    const handleEmployeesDropdown = async (e) => {
        e.preventDefault();
        setIsOpen(!isOpen)
    }
    
     
    const toggleAllEmployees = () => {
        const newCheckedState = !showAllEmployees;
        setShowAllEmployees(newCheckedState);
        const newCheckedItems = {};
        props?.arr.forEach(item => {
            newCheckedItems[item.id] = newCheckedState;
        });
        setCheckedItems(newCheckedItems);
    };
    
    const handleCheckboxChange = (id) => {
        setCheckedItems(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));
    };
    
    
  
  return (
    <FormDrawer display="center" size="sm" isOpen={isOpen} setIsOpen={setIsOpen}>
        <div className="relative px-4 py-5">
        <div className='mb-8'>
            <SearchBox 
                placeholder="Search Employee"
                name="employee"
            />
        </div>
        <div className="flex items-center justify-between px-4">
            <p className='' >Select All Employees</p>
                <SlideToggle 
                    active={showAllEmployees}
                    onChange={toggleAllEmployees}
                />
        </div>
        <form className="p-4">
            <div className="rounded-2xl border" style={{ height: "250px"}}>
                <div className='px-4 overflow-x-auto overflow-y-scroll' style={{ height: "230px", marginTop:"10px" }}>
            {props?.arr?.map((item, idx) => {
                const { id, name } = item;
                
                    return(<ul key={idx}>
                            <li className='flex gap-2 items-center'>
                            <input 
                                type="checkbox" 
                                checked={checkedItems[id] || false} 
                                onChange={() => handleCheckboxChange(id)}
                                name={id} 
                                id={id} 
                                className='appearance-none rounded-[4px] h-4 w-4 text-ep-primary focus:outline-none focus-within:border-transparent focus-within:ring-0'  
                            />
                            <div className={clsx('', listClass)} >
                                {name}
                            </div>
                        </li>
                    </ul>)
            }
            )}
            </div>
            </div>
            
            <div className="bg-white relative bottom-0">
                <button type='button' onClick={(e) => handleEmployeesDropdown(e)} className='btn btn-transparent-primary py-2.5 w-full mt-6 border border-[#D0D5DD]'>Add</button>
            </div>
        </form>
        </div>
    </FormDrawer>
  )
}

export default DropDownSearch
